export default {
  saving: 'Сохраняется...',
  savedSuccessfully: 'Успешно сохранено',
  errors: {
    requiredField: 'Поле обязательно для заполнения',
    positiveNumber: 'Укажите положительное число',
    positiveIntegerNumber: 'Укажите положительное целое число',
    invalidEmail: 'Введен не валидный Email',
    invalidUrl:
      'Некорректный url. Пример валидного url: https://example.com/path/',
    invalidErid: 'Внесите erid в формате 2RanymKJUZn',
    unsupportedFileType: 'Неподдерживаемый тип файла',
    audioFileTooLarge: 'Размер аудиофайла больше допустимого',
    audioFileUnreadable: 'Не удалось прочитать аудиофайл',
    audioDurationTooLong: (maxDuration: string) =>
      `Длительность аудио должна быть не более ${maxDuration}`,
    somethingWentWrong:
      'Произошла непредвиденная ошибка. Пожалуйста, обратитесь в службу технической поддержки.',
  },
}
